import {useEffect} from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'

const RedirectToLoginPage = ({fromLocation}) => {
  useEffect(() => {
    const currentUrl = window.location.href
    const query = qs.stringify({redirect_uri: currentUrl})
    window.location.replace(`/login?${query}`)
  }, [])

  return null
}

RedirectToLoginPage.propTypes = {
  fromLocation: PropTypes.object,
}

export default RedirectToLoginPage
